var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlanned(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.42708 6.74967H6.51042V9.87467H16.9271V6.74967H19.0104V11.958H21.0938V6.74967C21.0938 5.60384 20.1562 4.66634 19.0104 4.66634H14.6562C14.2187 3.45801 13.0729 2.58301 11.7188 2.58301C10.3646 2.58301 9.21875 3.45801 8.78125 4.66634H4.42708C3.28125 4.66634 2.34375 5.60384 2.34375 6.74967V21.333C2.34375 22.4788 3.28125 23.4163 4.42708 23.4163H10.6771V21.333H4.42708V6.74967ZM11.7188 4.66634C12.2917 4.66634 12.7604 5.13509 12.7604 5.70801C12.7604 6.28092 12.2917 6.74967 11.7188 6.74967C11.1458 6.74967 10.6771 6.28092 10.6771 5.70801C10.6771 5.13509 11.1458 4.66634 11.7188 4.66634Z",
    fill: "green"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0938 13.5205L15.375 19.2497L12.2396 16.1247L10.6771 17.6872L15.375 22.3747L22.6562 15.083L21.0938 13.5205Z",
    fill: "green"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanned);
export default __webpack_public_path__ + "static/media/Planned.864a2326a15eefcb81a1a311c1ffa5ad.svg";
export { ForwardRef as ReactComponent };